import React, { useEffect, useState } from "react";

import {
  Avatar,
  Box,
  Divider,
  IconButton,
  Link,
  Menu,
  MenuItem,
  Typography
} from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";
import { globalVariables } from "../../global/GlobalVariables";
import { getLoyaltyPoints, getProfileImage, signout } from "../user/BCPAuth";
import { useProcessing, useSignout } from "../user/BCPAuthReducers";
import { BCPCircleUser } from "../icons/bcp/BCPIcons";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { useTranslation } from "react-i18next";
const SUPPORTS_CMS = getEnvironmentVariable("SUPPORTS_CMS") === "true";
const IS_BCP = getEnvironmentVariable("IS_BCP") === "true";

const useStyles = makeStyles((theme) => ({
  headerMenu: {
    marginTop: theme?.spacing ? theme.spacing(1) : null
  },
  profileMenuUser: {
    display: "flex",
    flexDirection: "column",
    padding: theme?.spacing ? theme.spacing(2) : null
  }
}));

const menuItemSx = {
  color: "text.hint",
  fontSize: 16
};

export default function ProfileMenu({ authContext, navigate }) {
  const classes = useStyles();
  var [profileMenu, setProfileMenu] = useState(null);
  var [loyaltyPoints, setLoyaltyPoints] = useState(null);
  var [profileImage, setProfileImage] = useState(null);
  const globalVars = globalVariables();
  const useSignoutReducer = useSignout();
  const useProcessingReducer = useProcessing();

  const [menuItems, setMenuItems] = useState([]);

  const { t } = useTranslation("translation", {
    keyPrefix: "components.MainLayout"
  });

  useEffect(() => {
    const check = async () => {
      const menuItems = globalVars?.links?.profileMenu || [
        {
          label: t("myAccount"),
          url: "/account"
        }
      ];

      if (getEnvironmentVariable("NO_SUBSCRIPTIONS") !== "true") {
        menuItems.push({
          label: t("subscriptions"),
          url: "/account?active_tab=subscriptions"
        });
      }

      if (getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") === "true") {
        menuItems.push({
          label: t("myShop"),
          url: "/account/shop"
        });
      }

      if (
        (SUPPORTS_CMS &&
          (authContext?.authState?.identity?.isEditor ||
            authContext?.authState?.identity?.isAdmin === true)) ||
        authContext?.authState?.identity?.isAdmin === true ||
        authContext?.authState?.identity?.adminGameSystems?.length > 0
      ) {
        menuItems.push({ divider: true });
      }

      if (
        SUPPORTS_CMS &&
        (authContext?.authState?.identity?.isEditor ||
          authContext?.authState?.identity?.isAdmin === true)
      ) {
        menuItems.push({
          label: t("cmsDashboard"),
          url: "/cms/my-posts"
        });
      }

      if (
        authContext?.authState?.identity?.isAdmin === true ||
        authContext?.authState?.identity?.adminGameSystems?.length > 0
      ) {
        menuItems.push({
          label: t("adminSettings"),
          url: "/admin"
        });
      }

      menuItems.push({ divider: true });
      menuItems.push({
        label: t("help"),
        url: "/support"
      });

      if (IS_BCP) {
        menuItems.push({ label: t("signOut"), url: "/logout" });
      }
      setMenuItems(menuItems);

      if (getEnvironmentVariable("SUPPORTS_LOYALTY_STORE") === "true") {
        var newLoyaltyPoints = await getLoyaltyPoints(authContext?.authState);
        setLoyaltyPoints(newLoyaltyPoints);
      }

      var profileImageData = await getProfileImage(authContext?.authState);
      setProfileImage(profileImageData?.imgData);
    };
    check();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <IconButton
        aria-haspopup="true"
        color="inherit"
        aria-controls="profile-menu"
        onClick={(e) => {
          if (Boolean(profileMenu)) setProfileMenu(null);
          else setProfileMenu(e.currentTarget);
        }}
        size="large"
      >
        {!profileImage ? (
          <BCPCircleUser />
        ) : (
          <Avatar
            alt={
              authContext?.authState?.identity?.firstName ||
              authContext?.authState?.identity?.given_name
            }
            src={profileImage}
            sx={{
              width: 24,
              height: 24
            }}
          />
        )}
      </IconButton>
      <Menu
        id="profile-menu"
        open={Boolean(profileMenu)}
        anchorEl={profileMenu}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setProfileMenu(null)}
        className={classes.headerMenu}
        classes={{ paper: classes.profileMenu }}
        disableAutoFocusItem
        disableScrollLock
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            pt: 1,
            pb: 1,
            pl: 2,
            pr: 2
          }}
        >
          <Typography variant="h4" weight="medium">
            {`${
              authContext?.authState?.identity?.firstName ||
              authContext?.authState?.identity?.given_name ||
              ""
            }`}
          </Typography>

          {loyaltyPoints && (
            <Typography variant="caption">
              {`${loyaltyPoints.available || 0} LP`}
            </Typography>
          )}
        </Box>
        {menuItems?.length > 0 &&
          menuItems.map((menuItem, index) => {
            if (menuItem.divider) {
              return <Divider sx={{ mt: 1, mb: 1 }} />;
            }
            return (
              <Link
                key={index}
                href={menuItem.url}
                underline="none"
                style={{ textDecoration: "none" }}
              >
                <MenuItem sx={menuItemSx}>{menuItem.label}</MenuItem>
              </Link>
            );
          })}

        {!IS_BCP && (
          <Link
            noWrap
            variant="body2"
            onClick={async () => {
              await signout(useSignoutReducer, {
                setProcessing: useProcessingReducer
              });
            }}
            underline="none"
            style={{ textDecoration: "none" }}
          >
            <MenuItem>{t("signOut")}</MenuItem>
          </Link>
        )}
      </Menu>
    </>
  );
}
